import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { bemGenerator } from '@prisjakt/ui-base';
import Rating from '@prisjakt/ui-rating';
import Currency from '@prisjakt/ui-currency';

import './index.scss';

const styles = bemGenerator('product-alert-info', [
  'product-info-image',
  'product-info-name',
  'product-info-price',
]);

const ProductAlertInfo = ({ product }) =>
  product && (
    <div className={styles.block}>
      {product && product.media && product.media.first && (
        <Link to={product.pathName}>
          <img
            src={product.media.first}
            alt={product.name}
            className={styles['product-info-image']}
          />
        </Link>
      )}
      <div className={styles['product-info-name']}>
        <h2>
          <Link to={product.pathName}>{product.name}</Link>
        </h2>
        <Rating
          hide={product.userReviewSummary.count === 0}
          count={product.userReviewSummary.count}
          rate={product.userReviewSummary.rating}
          showCounter={false}
        />
      </div>
      {!!product.priceSummary.regular && (
        <div className={styles['product-info-price']}>
          <Currency price={product.priceSummary.regular} />
        </div>
      )}
    </div>
  );

ProductAlertInfo.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    pathName: PropTypes.string,
    media: PropTypes.object,
    priceSummary: PropTypes.object,
  }),
};

ProductAlertInfo.defaultTypes = {
  product: undefined,
};

export default ProductAlertInfo;
